<div class="timeTrack-modal">
  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          <span *ngIf="period?.in">Modificar</span>
          <span *ngIf="!(period?.in)">Añadir</span>
          Fichaje
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <!-- Formulario de Entrada -->
        <div class="row mb-2" *ngIf="!showPause">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Entrada </mat-label>
              <input matInput name="clockIn" formControlName="clockIn" type="datetime-local" style="line-height: 11px;"
                class="d-flex" #clockInInput
                [readonly]="isManax ? false : readOnly || timeTrack.clockInOrigin == 'app' " required>
              <mat-hint *ngIf="timeTrack.clockInOrigin == 'app'">Desde app movil</mat-hint>
            </mat-form-field>
            <mat-error *ngIf="f['clockIn']?.errors?.['required']">
              Entrada Obligatoria
            </mat-error>
            <mat-error *ngIf="f['clockIn']?.errors?.['tooEarly']">
              La marcación es muy antigua.
            </mat-error>
            <mat-error *ngIf="f['clockIn']?.errors?.['lowerThanLastOut']">
              La entrada no puede ser anterior a la ultima salida
            </mat-error>
          </div>
        </div>

        <!-- Formulario de Salida -->
        <div class="row mb-2" *ngIf="period?.in && !showPause">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Salida </mat-label>
              <input matInput name="clockOut" formControlName="clockOut" type="datetime-local" class="d-flex"
                style="line-height: 11px;" #clockOutInput
                [readonly]="isManax ? false : readOnly || timeTrack.clockOutOrigin == 'app'">
              <mat-hint *ngIf="timeTrack.clockOutOrigin == 'app'">Desde app movil</mat-hint>
            </mat-form-field>
            <mat-error *ngIf="f['clockOut']?.errors?.['lowerThanOut']">
              La marcación es menor a la Entrada.
            </mat-error>
            <mat-error *ngIf="f['clockOut']?.errors?.['higherThanNextIn']">
              La salida no puede ser mayor a la siguiente entrada
            </mat-error>
            <mat-error *ngIf="f['clockOut']?.errors?.['lowerThanLastIn']">
              La salida no puede ser menor a la entrada
            </mat-error>
          </div>
        </div>

        <!-- Duración Total de Descansos -->
        <div class="row mb-2">
          <div class="col-md-12 subtitle-section">
            Duración Total Descansos: {{period?.formattedPauseTime}}
          </div>
        </div>

        <!-- Duración Total Trabajada -->
        <div class="row mb-2" *ngIf="period?.totalWorkedTime">
          <div class="col-md-12 subtitle-section">
            Duración Total Trabajado: {{period?.formattedWorkedTime}}
          </div>
        </div>

        <!-- Mapa Actualizado -->
        <div class="row" *ngIf="timeTrack?.coordinates?.length">
          <div class="col-md-12">
            <google-map [center]="{ lat: timeTrack.coordinates?.[0] || 0, lng: timeTrack.coordinates?.[1] || 0 }"
              [zoom]="16" height="350px" width="100%" [options]="{ clickableIcons: false }">

              <!-- Marcador de Trabajo -->
              <map-marker [position]="{ lat: timeTrack.coordinates?.[0] || 0, lng: timeTrack.coordinates?.[1] || 0}"
                [options]="{ draggable: false }" label="Trabajo">
              </map-marker>

              <!-- Marcador de Entrada -->
              <map-marker *ngIf="period?.in?.location"
                [position]="{ lat: period.in.location[0], lng: period.in.location[1] }" [options]="{ draggable: false }"
                label="Entrada">
              </map-marker>

              <!-- Marcador de Salida -->
              <map-marker *ngIf="period?.out?.location"
                [position]="{ lat: period.out.location[0], lng: period.out.location[1] }"
                [options]="{ draggable: false }" label="Salida">
              </map-marker>

              <!-- Marcadores de inicio y fin de pausas -->
              <ng-container *ngFor="let pauses of period?.pauses; let i=index">
                <map-marker *ngIf="pauses?.pause?.location"
                  [position]="{ lat: pauses.pause.location[0], lng: pauses.pause.location[1] }"
                  [options]="{ draggable: false }" label="Inicio descanso {{i + 1}}">
                </map-marker>
                <map-marker *ngIf="pauses?.resume?.location"
                  [position]="{ lat: pauses.resume.location[0], lng: pauses.resume.location[1] }"
                  [options]="{ draggable: false }" label="Final descanso {{i + 1}}">
                </map-marker>
              </ng-container>
            </google-map>
          </div>
        </div>

        <!-- Guardar y Cancelar -->
        <div class="row" *ngIf="!readOnly && !showPause">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>